import type { Theme } from "@mui/material";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { makeTintedBackgroundFromColor } from "../utilities/colorHelper";

interface Props {
  label: string;
  color: string | ((theme: Theme) => string);
  height?: "default" | "smaller";
  icon?: React.ReactElement;
  withDot?: boolean;
  tooltipText?: string;
  neutral?: boolean;
}

const StatusChip = ({ label, color, height, icon, withDot, tooltipText, neutral }: Props) => {
  return (
    <Tooltip title={tooltipText} arrow>
      <Chip
        icon={icon}
        label={
          withDot ? (
            <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
              <Typography variant="h3" component="span">
                •
              </Typography>
              <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>
                {label}
              </Typography>
            </Stack>
          ) : (
            <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>
              {label}
            </Typography>
          )
        }
        sx={(t) => {
          const resolvedColor = typeof color === "function" ? color(t) : color;
          return {
            fontWeight: 500,
            minWidth: 0,
            bgcolor: neutral ? t.palette.background.paper : makeTintedBackgroundFromColor(t, resolvedColor),
            ...(neutral && { border: 1, borderColor: t.palette.action.selected }),
            color: resolvedColor,
            height: height === "smaller" ? 20 : undefined,
            "& .MuiChip-icon": { color: "inherit" },
          };
        }}
      />
    </Tooltip>
  );
};

export default StatusChip;
